export enum DataHooks {
  Root = 'reschedule-success-dialog',
  Title = 'reschedule-success-dialog-title',
  ServiceName = 'reschedule-success-dialog-service-name',
  DateTime = 'reschedule-success-dialog-date-time',
  StaffMember = 'reschedule-success-dialog-staff-member',
  Location = 'reschedule-success-dialog-location',
  Participants = 'reschedule-success-dialog-participants',
  ConfirmButton = 'reschedule-success-dialog-confirm-button',
}
